import * as React from 'react';
import { isURLOrBase64 } from '@/utils/utils';

export const OnSelectedIcon = (props: IObj) => {
  if (isURLOrBase64(props.color)) {
    return (
      <div
        style={{
          ...props.style,
          backgroundImage: `url(${props.color})`,
          backgroundSize: '100% 100%',
        }}
      />
    );
  } else {
    return (
      <svg
        style={{
          ...props.style,
          display: 'block',
        }}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm0 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
          fill={props.color}
          fillRule="evenodd"
        />
      </svg>
    );
  }
};

export const UnSelectedIcon = (props: IObj) => {
  if (isURLOrBase64(props.color)) {
    return (
      <div
        style={{
          ...props.style,
          backgroundImage: `url(${props.color})`,
          backgroundSize: '100% 100%',
        }}
      />
    );
  } else {
    return (
      <svg
        style={{
          ...props.style,
          display: 'block',
        }}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18zm0-1.125a7.875 7.875 0 1 1 0-15.75 7.875 7.875 0 0 1 0 15.75z"
          fill={props.color}
          fillRule="nonzero"
        />
      </svg>
    );
  }
};

export const CloseIcon = (props: IObj) => (
  <svg
    style={{
      ...props.style,
      display: 'block',
    }}
    x="0px"
    y="0px"
    viewBox="0 0 20 20"
  >
    <g transform="translate(3.875000, 3.875000)">
      <path
        id="Stroke-1"
        fill={props.color}
        d="M0.6,1.3c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l10.3,10.3c0.2,0.2,0.2,0.5,0,0.7s-0.5,0.2-0.7,0
            L0.6,1.3z"
      />
      <path
        fill={props.color}
        d="M1.3,11.6c-0.2,0.2-0.5,0.2-0.7,0s-0.2-0.5,0-0.7L10.9,0.6c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7
            L1.3,11.6z"
      />
    </g>
  </svg>
);

export const SelectIcon = (props: IObj) => {
  const {
    selected,
    expected,
    style,
    onSelectedIconColor,
    unSelectedIconColor,
  } = props;
  return selected === expected ? (
    <OnSelectedIcon style={style} color={onSelectedIconColor} />
  ) : (
    <UnSelectedIcon style={style} color={unSelectedIconColor} />
  );
};
